import { render } from "./LoginPage.vue?vue&type=template&id=60c38f6e&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=60c38f6e&scoped=true&lang=css"

import exportComponent from "/working_dir/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c38f6e"]])

export default __exports__